import { Icon } from '@udemy/icons';
import classNames from 'classnames';
import React from 'react'; // Note: PlayOverlay CSS is served up via the react-structure-components.global.css file;

/** React props interface for the `PlayOverlay` component */

/**
 * ### The PlayOverlay component.
 *
 * @remarks
 * This component is used to render a play icon on top of an image.
 *
 * This component requires global CSS.
 * You must add this import to your application's `_app.tsx` global CSS import manifest:
 *
 * @example
 * `@import '~@udemy/react-structure-components/dist/react-structure-components.global.css';`
 */
export const PlayOverlay = _ref => {
  let {
    size = 'xlarge',
    className
  } = _ref;
  return /*#__PURE__*/React.createElement("span", {
    className: classNames('ud-play-overlay', className)
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: "play-overlay",
    label: false,
    className: "ud-focus-visible-target",
    color: "inherit",
    size: size
  }));
};
//# sourceMappingURL=play-overlay.react-component.js.map